import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AUTH_REDIRECT_STATE_KEY, AuthRedirectReason } from 'app/core/auth/auth-redirect-reason';
import { AuthLogoutService } from 'app/core/auth/services/auth-logout.service';

@UntilDestroy()
@Component({
    selector: 'logout',
    templateUrl: './logout.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class LogoutComponent implements OnInit {
    countdown = 5;
    countdownMapping: Record<string, string> = {
        '=1': '# second',
        other: '# seconds',
    };

    constructor(
        private authLogoutService: AuthLogoutService,
        private router: Router
    ) {}

    async ngOnInit(): Promise<void> {
        const navigationState = this.router.getCurrentNavigation()?.extras?.state;
        const historyState = history.state as Record<string, unknown> | undefined;
        const triggerReason =
            (navigationState?.[AUTH_REDIRECT_STATE_KEY] as AuthRedirectReason | undefined) ??
            (historyState?.[AUTH_REDIRECT_STATE_KEY] as AuthRedirectReason | undefined) ??
            'unknown';

        await this.authLogoutService.performLogout(
            this.authLogoutService.getApplicationBaseUrl(),
            triggerReason
        );
    }
}
